import {
  Sidebar,
  SidebarBody,
  SidebarFooter,
  SidebarSection,
  SidebarHeader,
  SidebarHeading,
} from "../catalyst/sidebar";

import HpglLogo from "../../assets/HPGL-logo.png";
import HpglLogoDark from "../../assets/Hpgl-logo-dark.png";
import { navigation, subNavigation } from "./navigationMenuData";
import { SidebarItem } from "./SidebarItem";
import { Heading } from "../catalyst/heading";

import { CurrentUserLogout } from "./CurrentUserLogout";

export const CommonSideBar: React.FC<any> = ({
  showSeason,
  seasonName,
  onClick,
  currentSeason,
  currentUser
}) => {
  return (
    <Sidebar className="z-[200]">
      <SidebarHeader>
        <div className="flex shrink-0 items-center">
          <img alt="HPGL" src={HpglLogo} className="h-8 w-10 dark:hidden" />
          <img
            alt="HPGL"
            src={HpglLogoDark}
            className="h-8 w-10 hidden dark:block"
          />
          <Heading level={2} className="ml-5">
            HPGL
          </Heading>
        </div>
      </SidebarHeader>
      <SidebarBody>
        <SidebarSection>
          <ul role="list" className="flex flex-1 flex-col">
            {navigation.map((item) => (
              <SidebarItem key={item.name} item={item} onClick={onClick} />
            ))}
          </ul>
        </SidebarSection>
        {currentSeason && showSeason && (
          <SidebarSection>
            <SidebarHeading>{seasonName}</SidebarHeading>
            <ul role="list" className="flex flex-1 flex-col">
              {subNavigation.map((item) => {
                if (item.roles && currentUser && !item.roles.includes(currentUser.role)) {
                  return null;
                }

                if (
                  item.seasonPropName &&
                  currentSeason &&
                  (!Object.prototype.hasOwnProperty.call(
                    currentSeason,
                    item.seasonPropName
                  ) ||
                    (Object.prototype.hasOwnProperty.call(
                      currentSeason,
                      item.seasonPropName
                    ) &&
                      !currentSeason[item.seasonPropName]))
                ) {
                  return null;
                }
                return <SidebarItem key={item.name} item={item} onClick={onClick} />;
              })}
            </ul>
          </SidebarSection>
        )}
      </SidebarBody>
      <SidebarFooter>
        <SidebarSection>
          <CurrentUserLogout />
        </SidebarSection>
      </SidebarFooter>
    </Sidebar>
  );
};

export const MainSidebar: React.FC<any> = ({ currentSeason, currentUser }) => {
  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col main-sidebar">
      <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white dark:bg-gray-900">
        <CommonSideBar
          showSeason={currentSeason ? true : false}
          seasonName={currentSeason ? currentSeason.seasonName : ""}
          currentSeason={currentSeason}
          currentUser={currentUser}
        />
      </div>
    </div>
  );
};
